export interface TranslationStore {
  [language: string]: {
    [scope: string]: Record<string, any>;
  };
}

/**
 * Get translation for a specific language and scope
 */
export function getTranslation(
  language: string,
  scope: string = 'root'
): Record<string, any> {
  return translationStore[language]?.[scope] || {};
}

/**
 * Get all available languages
 */
export function getAvailableLanguages(): string[] {
  return Object.keys(translationStore);
}

/**
 * Get all available scopes for a language
 */
export function getAvailableScopes(language: string): string[] {
  return Object.keys(translationStore[language] || {});
}

// This will be imported from the generated file
// Use a fallback empty store if the generated file doesn't exist yet
let translationStore: TranslationStore = {};

try {
  const generated = require('./translation-store.generated');
  translationStore = generated.translationStore || {};
} catch (error) {
  // Generated file doesn't exist yet, use empty store
  translationStore = {};
}

export { translationStore };
